import React,{useEffect, useRef } from 'react'
import styled from "styled-components"
import {useSelector} from "react-redux"


const ProgressEpg = styled.div`
  display: flex;
  width: 100%;
  height: 0.35rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: rgba(130, 145, 150, 0.25);
  border-radius: 999px;
`

const ProgressBar = styled.div`
display: -ms-flexbox;
display: flex;
-ms-flex-direction: column;
flex-direction: column;
-ms-flex-pack: center;
justify-content: center;
overflow: hidden;
color: #fff;
text-align: center;
white-space: nowrap;
transition: width .6s ease;
border-radius: 999px;
`

const ChannelEpgBar = ({start,stop, isPlaying}) => {
    const timer = useSelector(state => state.timer5);

    const progress = useRef(0);

    const ProgressBarStyle = isPlaying ? {
        backgroundColor: "#fff",
        border: "1px solid #829196"
    } : {
        backgroundColor: "#829196"
    };
    const percentage = start ? Math.min(100, Math.max(0, ((timer-start)/(stop-start))*100)) : 0;
    ProgressBarStyle.width = `${percentage}%`;

    useEffect(() => {
        if (progress.current) {
            if(start && stop && stop !== start) {
                const currentPercentage = Math.min(100, Math.max(0, ((timer-start)/(stop-start))*100));
                progress.current.style.width = `${currentPercentage}%`;
            } else {
                progress.current.style.width = "0%";
            }
        }
    }, [isPlaying,timer,start,stop]);

    return (
        <ProgressEpg>
            <ProgressBar role="progressbar" ref={progress} style={ProgressBarStyle} className={"progressBar"}></ProgressBar>
        </ProgressEpg>
    )
}

export default ChannelEpgBar
